module.exports = __webpack_public_path__ + "img/carrefour_nord.81550477.webp";